export const ManualAssetsAccountTypes = [
  "Private Investment Holding",
  "Real Estate",
  "Crypto",
  "Collectable",
] as const;

export type ManualAssetsAccountType = typeof ManualAssetsAccountTypes[number];
